import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import { IconName } from "PFTheme/graphics/icons";
import React from "react";

import { TileButton } from "../tile_button";
import css from "./tile.module.scss";

type TileClasses = {
  mainContainer?: string;
  title?: string;
};

export type TileProps = {
  title: string;
  classes?: TileClasses;
  label?: string;
  onClick?: () => void;
  iconName?: IconName;
  headerAdditionalContent?: JSX.Element;
};

export const Tile = ({
  title,
  children,
  onClick,
  iconName,
  label,
  classes = {},
  headerAdditionalContent
}: React.PropsWithChildren<TileProps>): JSX.Element => (
  <div className={classNames(css.mainContainer, classes.mainContainer)}>
    <div className={css.header}>
      <Typography variant="h4" noMargin className={classes.title}>
        {title}
      </Typography>
      {headerAdditionalContent}
    </div>
    <div className={css.content}>{children}</div>
    {onClick && (
      <TileButton onClick={onClick} iconName={iconName}>
        {label}
      </TileButton>
    )}
  </div>
);
